export class NoteAuthor {
    private _id: string = "";
    private _firstName: string = "";
    private _lastName: string = "";

    constructor(id: string, firstName: string, lastName: string) {
        this._id = id;
        this._firstName = firstName;
        this._lastName = lastName;
    }

    get id() {
        return this._id;
    }

    get firstName() {
        return this._firstName;
    }

    get lastName() {
        return this._lastName;
    }

    get fullName() {
        return this._lastName.concat(" ").concat(this._firstName);
    }
}